/**
 * Settings sidebar sections.
 * `organization` — day-to-day tenant configuration.
 * `advancedSettings` — templates, feature metadata, and raw config tools.
 */
export const sectionTitles = {
  organization: "Organization",
  advancedSettings: "Advanced Settings",
};

export const menu = {
  organization: [
    "General",
    "Rates",
    // "Dispatch",
    "Fleet",
    "Drivers",
    "Users",
    "Billing",
    "Reports",
    "Tags",
    "Google Drive",
  ],
  advancedSettings: [
    "Roles Permissions",
    "Integrations",
    "Templates",
    // "PDF Templates",
    // "Task Templates",
    // "Notification Templates",
    // "Feedback",
    // "Naming Conventions",
    // "History",
    // "Features",
    // "Advanced",
  ],
};
